import { constants as GenericConstants, Field as GenericField, StorageKeysModel } from 'common';

export class Field extends GenericField {}

export const storageKeys: StorageKeysModel = {
  auth: 'iSHARE.SO.auth',
  profile: 'iSHARE.SO.profile',
  logging: 'iSHARE.SO.logging',
  authExpiration: 'iSHARE.SO.authExpiration',
  settings: 'iSHARE.SO.settings',
  refreshToken: 'iSHARE.SO.refreshToken'
};

export const constants = {
  storage: storageKeys,
  roles: GenericConstants.roles,
  so: {
    certificateTypes: {
      pkio: new Field('PKIo', 'Pkio'),
      isharetest: new Field('iSHARE Test', 'IshareTest'),
      eidas: new Field('eIDAS', 'Eidas')
    },
    validity: {
      Valid: new Field('Valid', 'Valid'),
      Invalid: new Field('Invalid', 'Invalid')
    },
    status1: {
      Granted: new Field('Granted', 'Granted'),
      Withdrawn: new Field('Withdrawn', 'Withdrawn'),
      SupervisionCeased: new Field('Supervision Ceased', 'Supervision Ceased'),
      UnderSupervision: new Field('Under Supervision', 'Under Supervision')
    },
    statuses: {
      New: new Field('New', 'New'),
      InProgress: new Field('In Progress', 'InProgress'),
      Active: new Field('Active', 'Active'),
      NotActive: new Field('Not Active', 'NotActive')
    },
    country: {
      Afghanistan: new Field('Afghanistan', 'Afghanistan'),
      Albania: new Field('Albania', 'Albania'),
      Algeria: new Field('Algeria', 'Algeria'),
      AmericanSamoa: new Field('American Samoa', 'American Samoa'),
      Andorra: new Field('Andorra', 'Andorra'),
      Angola: new Field(' Angola', ' Angola'),
      Anguilla: new Field('Anguilla', 'Anguilla'),
      Antigua: new Field('Antigua', 'Antigua'),
      Barbuda: new Field('Barbuda', 'Barbuda'),
      Argentina: new Field('Argentina', 'Argentina'),
      Armenia: new Field(' Armenia', ' Armenia'),
      Aruba: new Field('Aruba', 'Aruba'),
      Australia: new Field('Australia', 'Australia'),
      Austria: new Field('Austria', 'Austria'),
      Azerbaijan: new Field('Azerbaijan', 'Azerbaijan'),
      Bahamas: new Field('Bahamas', 'Bahamas'),
      Bahrain: new Field('Bahrain', 'Bahrain'),
      Bangladesh: new Field('Bangladesh', 'Bangladesh'),
      Barbados: new Field('Barbados', 'Barbados'),
      Belarus: new Field('Belarus', 'Belarus'),
      Belgium: new Field('Belgium', 'Belgium'),
      Belize: new Field('Belize', 'Belize'),
      Benin: new Field('Benin', 'Benin'),
      Bermuda: new Field('Bermuda', 'Bermuda'),
      Bhutan: new Field('Bhutan', 'Bhutan'),
      Bolivia: new Field('Bolivia', 'Bolivia'),
      Bonaire: new Field('Bonaire', 'Bonaire'),
      SintEustatius: new Field('Sint Eustatius', 'Sint Eustatius'),
      Bosnia: new Field(' Bosnia', ' Bosnia'),
      Herzegovina: new Field('Herzegovina', 'Herzegovina'),
      Botswana: new Field(' Botswana', ' Botswana'),
      BouvetIsland: new Field('Bouvet Island', 'Bouvet Island'),
      Brazil: new Field('Brazil', 'Brazil'),
      BritishIndianOceanTerritory: new Field('British Indian Ocean Territory', 'British Indian Ocean Territory'),
      BritishVirginIslands: new Field('British Virgin Islands', 'British Virgin Islands'),
      BruneiDarussalam: new Field('Brunei Darussalam', 'Brunei Darussalam'),
      Bulgaria: new Field('Bulgaria', 'Bulgaria'),
      BurkinaFaso: new Field('Burkina Faso', 'Burkina Faso'),
      Burma: new Field('Burma', 'Burma'),
      Burundi: new Field('Burundi', 'Burundi'),
      CaboVerde: new Field('Cabo Verde', 'Cabo Verde'),
      Cambodia: new Field('Cambodia', 'Cambodia'),
      Cameroon: new Field('Cameroon', 'Cameroon'),
      Canada: new Field('Canada', 'Canada'),
      CapeVerde: new Field('Cape Verde', 'Cape Verde'),
      CaribbeanNetherlands: new Field('Caribbean Netherlands', 'Caribbean Netherlands'),
      CaymanIslands: new Field('Cayman Islands', 'Cayman Islands'),
      CentralAfricanRepublic: new Field('Central African Republic', 'Central African Republic'),
      Chad: new Field('Chad', 'Chad'),
      Chile: new Field(' Chile', ' Chile'),
      China: new Field('China', 'China'),
      ChristmasIsland: new Field('Christmas Island', 'Christmas Island'),
      CocosIslands: new Field('Cocos Islands', 'Cocos Islands'),
      Colombia: new Field('Colombia', 'Colombia'),
      Comoros: new Field('Comoros', 'Comoros'),
      Congo: new Field(' Congo', ' Congo'),
      CookIslands: new Field('Cook Islands', 'Cook Islands'),
      CostaRica: new Field(' Costa Rica', ' Costa Rica'),
      Croatia: new Field('Croatia', 'Croatia'),
      Cuba: new Field('Cuba', 'Cuba'),
      Curaçao: new Field('Curaçao', 'Curaçao'),
      Cyprus: new Field('Cyprus', 'Cyprus'),
      Czechia: new Field('Czechia', 'Czechia'),
      Denmark: new Field('Denmark', 'Denmark'),
      Djibouti: new Field('Djibouti', 'Djibouti'),
      Dominica: new Field('Dominica', 'Dominica'),
      EastTimor: new Field(' East Timor', ' East Timor'),
      Ecuador: new Field('Ecuador', 'Ecuador'),
      Egypt: new Field('Egypt', 'Egypt'),
      ElSalvador: new Field('El Salvador', 'El Salvador'),
      EquatorialGuinea: new Field(' Equatorial Guinea', ' Equatorial Guinea'),
      Eritrea: new Field('Eritrea', 'Eritrea'),
      Estonia: new Field('Estonia', 'Estonia'),
      Eswatini: new Field(' Eswatini', ' Eswatini'),
      Ethiopia: new Field('Ethiopia', 'Ethiopia'),
      FalklandIslands: new Field(' Falkland Islands', ' Falkland Islands'),
      FaroeIslands: new Field('Faroe Islands', 'Faroe Islands'),
      Fiji: new Field('Fiji', 'Fiji'),
      Finland: new Field(' Finland', ' Finland'),
      France: new Field(' France', ' France'),
      FrenchGuiana: new Field('French Guiana', 'French Guiana'),
      FrenchPolynesia: new Field('French Polynesia', 'French Polynesia'),
      FrenchSouthernTerritories: new Field('French Southern Territories', 'French Southern Territories'),
      Gabon: new Field('Gabon', 'Gabon'),
      Gambia: new Field('Gambia', 'Gambia'),
      Georgia: new Field('Georgia', 'Georgia'),
      Germany: new Field('Germany', 'Germany'),
      Ghana: new Field('Ghana', 'Ghana'),
      Gibraltar: new Field('Gibraltar', 'Gibraltar'),
      GreatBritain: new Field('Great Britain', 'Great Britain'),
      Greece: new Field('Greece', 'Greece'),
      Greenland: new Field('Greenland', 'Greenland'),
      Grenada: new Field('Grenada', 'Grenada'),
      Guadeloupe: new Field('Guadeloupe', 'Guadeloupe'),
      Guam: new Field(' Guam', 'Guam'),
      Guatemala: new Field('Guatemala', 'Guatemala'),
      Guernsey: new Field('Guernsey', 'Guernsey'),
      Guinea: new Field('Guinea', 'Guinea'),
      GuineaBissau: new Field('Guinea-Bissau', 'Guinea-Bissau'),
      Guyana: new Field('Guyana', 'Guyana'),
      Haiti: new Field('Haiti', 'Haiti'),
      Honduras: new Field(' Honduras', ' Honduras'),
      HongKong: new Field('Hong Kong', 'Hong Kong'),
      Hungary: new Field('Hungary', 'Hungary'),
      Iceland: new Field(' Iceland', ' Iceland'),
      India: new Field('India', 'India'),
      Indonesia: new Field('Indonesia', 'Indonesia'),
      Iran: new Field('Iran', 'Iran'),
      Iraq: new Field(' Iraq', ' Iraq'),
      Ireland: new Field(' Ireland', ' Ireland'),
      IsleofMan: new Field(' Isle of Man', ' Isle of Man'),
      Israel: new Field(' Israel', ' Israel'),
      Italy: new Field('Italy', 'Italy'),
      IvoryCoast: new Field('Ivory Coast', 'Ivory Coast'),
      Jamaica: new Field('Jamaica', 'Jamaica'),
      Japan: new Field('Japan', 'Japan'),
      Jersey: new Field('Jersey', 'Jersey'),
      Jordan: new Field('Jordan', 'Jordan'),
      Kazakhstan: new Field('Kazakhstan', 'Kazakhstan'),
      Kenya: new Field('Kenya', 'Kenya'),
      Kiribati: new Field('Kiribati', 'Kiribati'),
      Korea: new Field(' Korea', ' Korea'),
      Kuwait: new  Field('Kuwait', 'Kuwait'),
      Kyrgyzstan: new Field(' Kyrgyzstan', ' Kyrgyzstan'),
      Latvia: new Field('Latvia', 'Latvia'),
      Lebanon: new Field('Lebanon', 'Lebanon'),
      Lesotho: new Field('Lesotho', 'Lesotho'),
      Liberia: new Field('Liberia', 'Liberia'),
      Libya: new Field('Libya', 'Libya'),
      Liechtenstein: new Field(' Liechtenstein', ' Liechtenstein'),
      Lithuania: new Field('Lithuania', 'Lithuania'),
      Luxembourg: new Field('Luxembourg', 'Luxembourg'),
      Macao: new Field('Macao', 'Macao'),
      NorthMacedonia: new Field('North Macedonia', 'North Macedonia'),
      Madagascar: new Field(' Madagascar', ' Madagascar'),
      Malawi: new Field('Malawi', 'Malawi'),
      Malaysia: new Field('Malaysia', 'Malaysia'),
      Maldives: new Field('Maldives', 'Maldives'),
      Mali: new Field('Mali', 'Mali'),
      Malta: new Field(' Malta', ' Malta'),
      MarshallIslands: new Field('Marshall Islands', 'Marshall Islands'),
      Martinique: new Field('Martinique', 'Martinique'),
      Mauritania: new Field('Mauritania', 'Mauritania'),
      Mauritius: new Field('Mauritius', 'Mauritius'),
      Mayotte: new Field('Mayotte', 'Mayotte'),
      Mexico: new Field('Mexico', 'Mexico'),
      Micronesia: new Field(' Micronesia', ' Micronesia'),
      Moldova: new Field('Moldova', 'Moldova'),
      Monaco: new Field('Monaco', 'Monaco'),
      Mongolia: new Field('Mongolia', 'Mongolia'),
      Montenegro: new Field('Montenegro', 'Montenegro'),
      Montserrat: new Field('Montserrat', 'Montserrat'),
      Morocco: new Field('Morocco', 'Morocco'),
      Mozambique: new Field('Mozambique', 'Mozambique'),
      Myanmar: new Field(' Myanmar', ' Myanmar'),
      Namibia: new Field('Namibia', 'Namibia'),
      Nauru: new Field('Nauru', 'Nauru'),
      Nepal: new Field('Nepal', 'Nepal'),
      Netherlands: new Field(' Netherlands', ' Netherlands'),
      NewCaledonia: new Field('New Caledonia', 'New Caledonia'),
      NewZealand: new Field('New Zealand', 'New Zealand'),
      Nicaragua: new Field('Nicaragua', 'Nicaragua'),
      Niger: new Field(' Niger', ' Niger'),
      Nigeria: new Field('Nigeria', 'Nigeria'),
      Niue: new Field('Niue', 'Niue'),
      NorfolkIsland: new Field(' Norfolk Island', ' Norfolk Island'),
      NorthKorea: new Field(' North Korea', ' North Korea'),
      NorthernIreland: new Field('Northern Ireland', 'Northern Ireland'),
      NorthernMarianaIslands: new Field('Northern Mariana Islands', 'Northern Mariana Islands'),
      Norway: new Field('Norway', 'Norway'),
      Oman: new Field('Oman', 'Oman'),
      Pakistan: new Field('Pakistan', 'Pakistan'),
      Palau: new Field('Palau', 'Palau'),
      Palestine: new Field('Palestine', 'Palestine'),
      Panama: new Field('Panama', 'Panama'),
      PapuaNewGuinea: new Field('Papua New Guinea', 'Papua New Guinea'),
      Paraguay: new Field('Paraguay', 'Paraguay'),
      Peru: new Field('Peru', 'Peru'),
      Philippines: new Field('Philippines', 'Philippines'),
      Pitcairn: new Field('Pitcairn', 'Pitcairn'),
      Poland: new Field(' Poland', ' Poland'),
      Portugal: new Field('Portugal', 'Portugal'),
      PuertoRico: new Field('Puerto Rico', 'Puerto Rico'),
      Qatar: new Field('Qatar', 'Qatar'),
      Romania: new Field('Romania', 'Romania'),
      RussianFederation: new Field('Russian Federation', ' Russian Federation'),
      Rwanda: new Field('Rwanda', 'Rwanda'),
      Saba: new Field('Saba', 'Saba'),
      SaintBarthélemy: new Field('Saint Barthélemy', 'Saint Barthélemy'),
      SaintLucia: new Field(' Saint Lucia', ' Saint Lucia'),
      SaintMartin: new Field('SaintMartin', 'SaintMartin'),
      SaintPierre: new Field('Saint Pierre', 'Saint Pierre'),
      SaintVincent: new Field('Saint Vincent', 'Saint Vincent'),
      Samoa: new Field('Samoa', 'Samoa'),
      SanMarino: new Field('San Marino', 'San Marino'),
      SaoTomeandPrincipe: new Field('Sao Tome and Principe', 'Sao Tome and Principe'),
      SaudiArabia: new Field('Saudi Arabia', 'Saudi Arabia'),
      Scotland: new Field('Scotland', 'Scotland'),
      Senegal: new Field('Senegal', 'Senegal'),
      Serbia: new Field('Serbia', 'Serbia'),
      Seychelles: new Field('Seychelles', 'Seychelles'),
      SierraLeone: new Field('Sierra Leone', 'Sierra Leone'),
      Singapore: new Field('Singapore', 'Singapore'),
      SintMaarten: new Field('Sint Maarten', 'Sint Maarten'),
      Slovakia: new Field('Slovakia', 'Slovakia'),
      Slovenia: new Field('Slovenia', 'Slovenia'),
      SolomonIslands: new Field('Solomon Islands', 'Solomon Islands'),
      Somalia: new Field('Somalia', 'Somalia'),
      SouthAfrica: new Field('South Africa', 'South Africa'),
      SouthGeorgia: new Field('South Georgia', 'South Georgia'),
      SouthKorea: new Field(' South Korea', ' South Korea'),
      SouthSudan: new Field('South Sudan', 'South Sudan'),
      Spain: new Field('Spain', 'Spain'),
      SriLanka: new Field('Sri Lanka', 'Sri Lanka'),
      Sudan: new Field(' Sudan', ' Sudan'),
      Suriname: new Field('Suriname', 'Suriname'),
      Svalbard: new Field('Svalbard', 'Svalbard'),
      Sweden: new Field('Sweden', 'Sweden'),
      Switzerland: new Field('Switzerland', 'Switzerland'),
      SyrianArabRepublic: new Field('Syrian Arab Republic', 'Syrian Arab Republic'),
      Taiwan: new Field('Taiwan', 'Taiwan'),
      Tajikistan: new Field('Tajikistan', 'Tajikistan'),
      Tanzania: new Field('Tanzania', 'Tanzania'),
      Thailand: new Field('Thailand', 'Thailand'),
      TimorLeste: new Field(' Timor-Leste', ' Timor-Leste'),
      Togo: new Field('Togo', 'Togo'),
      Tokelau: new Field('Tokelau', 'Tokelau'),
      Tonga: new Field('Tonga', 'Tonga'),
      Trinidad: new Field('Trinidad', 'Trinidad'),
      Tobago: new Field('Tobago', 'Tobago'),
      Tunisia: new Field('Tunisia', 'Tunisia'),
      Turkey: new Field('Turkey', 'Turkey'),
      Turkmenistan: new Field('Turkmenistan', 'Turkmenistan'),
      Tuvalu: new Field('Tuvalu', 'Tuvalu'),
      Uganda: new Field('Uganda', 'Uganda'),
      Ukraine: new Field('Ukraine', 'Ukraine'),
      UnitedArabEmirates: new Field('United Arab Emirates', 'United Arab Emirates'),
      Uruguay: new Field('Uruguay', 'Uruguay'),
      Uzbekistan: new Field('Uzbekistan', 'Uzbekistan'),
      Vanuatu: new Field('Vanuatu', 'Vanuatu'),
      VaticanCity: new Field('Vatican City', 'Vatican City'),
      Venezuela: new Field('Venezuela', 'Venezuela'),
      VietNam: new Field(' VietNam', ' VietNam'),
      VirginIslands: new Field('Virgin Islands', 'Virgin Islands'),
      Wales: new Field('Wales', 'Wales'),
      Wallis: new Field('Wallis', 'Wallis'),
      WesternSahara: new Field('Western Sahara', 'Western Sahara'),
      Yemen: new Field('Yemen', 'Yemen'),
      Zambia: new Field('Zambia', 'Zambia'),
      Zimbabwe: new Field('Zimbabwe', 'Zimbabwe')
    },
    adherenceStatuses: {
      Active: new Field('Active', 'Active'),
      Revoked: new Field('Revoked', 'Revoked'),
      NotActive: new Field('Not Active', 'NotActive'),
      Pending: new Field('Pending', 'Pending')
    },
    roles: {
      ServiceConsumer: new Field('Service Consumer', 'ServiceConsumer'),
      ServiceProvider: new Field('Service Provider', 'ServiceProvider'),
      EntitledParty: new Field('Entitled Party', 'EntitledParty'),
      AuthorisationRegistry: new Field('Authorisation Registry', 'AuthorisationRegistry'),
      IdentityProvider: new Field('Identity Provider', 'IdentityProvider'),
      IdentityBroker: new Field('Identity Broker', 'IdentityBroker')
    },
    roles1: {
      ServiceConsumer: new Field('Service Consumer', 'ServiceConsumer'),
      ServiceProvider: new Field('Service Provider', 'ServiceProvider'),
      EntitledParty: new Field('Entitled Party', 'EntitledParty'),
      AuthorisationRegistry: new Field('Authorisation Registry', 'AuthorisationRegistry'),
      IdentityProvider: new Field('Identity Provider', 'IdentityProvider'),
      IdentityBroker: new Field('Identity Broker', 'IdentityBroker')
    },
    userRoles: {
      SchemeOwner: new Field('Scheme Owner', 'SchemeOwner'),
      SatelliteAdmin: new Field('SatelliteAdmin', 'SatelliteAdmin'),
      PartyAdmin: new Field('PartyAdmin', 'PartyAdmin'),
      User: new Field('User', 'User')
    },
    loas: {
      Low: new Field('Low', 'Low'),
      Substantial: new Field('Substantial', 'Substantial'),
      High: new Field('High', 'High')
    }, agreementStatus: {
      Draft : new Field('Draft', 'Draft'),
      Signed: new Field('Signed', 'Signed'),
      Accepted: new Field('Accepted', 'Accepted'),
      Obsolete: new Field('Obsolete', 'Obsolete')
    },
    type: {
      TermsOfUse: new Field('Terms Of Use', 'TermsOfUse'),
      AccessionAgreement: new Field('Accession Agreement', 'AccessionAgreement'),
      CertifiedPartyAgreement: new Field('Certified Party Agreement', 'CertifiedPartyAgreement'),
      SatelliteAgreement: new Field('Satellite Agreement', 'SatelliteAgreement')
    },
    certStatus: {
      Revoked: new Field('Revoked', 'Revoked'),
      // Uploaded: new Field('Uploaded', 'Uploaded'),
      // Expired: new Field('Expired', 'Expired'),
      Active: new Field('Active', 'Active'),
    },
    searchList: {
      ID : new Field('ID', 'id'),
      PartyName: new Field('Party Name', 'partyName'),
      AdherenceStartDate : new Field('Adherence Date', 'adherenceStartdate'),
      AdherenceStatus: new Field('Adherence Status', 'adherenceStatus'),
      Registrar: new Field('Registrar Satellite ID', 'registarSatelliteID'),
      AuthorisationID: new Field('Authorisation Registry ID', 'authorizationRegistryID'),
      AuthorisationName: new Field('Authorisation Registry Name', 'authorizationRegistryName'),
      WebsiteUrl: new Field('Website Url', 'webSiteUrl'),
      CompanyEmail: new Field('Company Email', 'companyEmail'),
      CompanyPhone: new Field('Company Phone', 'companyPhone'),
      CountriesOfOperation: new Field('Countries Of Operation', 'countriesOfOperation'),
      SectorIndustry: new Field('Sector Industry', 'sectorIndustry'),
      Tags: new Field('Tags', 'tags'),
      // tslint:disable-next-line:comment-format
      //PubliclyPublishable: new Field('Publicly Publishable', 'publiclyPublishable'),
      DataspaceID: new Field('Dataspace ID', 'dataSpaceID'),
      DataspaceTitle: new Field('Dataspace Title', 'dataSpaceTitle'),
      Certificate : new Field('Subject', 'subjectName'),
      Framework : new Field('Framework', 'framework'),
      Role : new Field('Role', 'role'),
      LoA : new Field('LoA', 'loA'),
      CompliancyVerified: new Field('Compliancy Verified', 'compliancyVerified'),
      LegalAdherence: new Field('Legal Adherence', 'legalAdherence')
    },
    searchList1: {
      DataspaceID : new Field('Dataspace ID', 'dataspaceID'),
      Title: new Field('Title', 'subject'),
      Status: new Field('Status', 'status'),
    },
    searchList2: {
      Subject : new Field('Subject', 'subject'),
      Validity: new Field('Validity', 'validity'),
      Status: new Field('Status', 'status'),
    },
    searchList3: {
      PartyId : new Field('PartyId', 'partyId'),
      // Creator : new Field('Creator Org', 'creatorOrg'),
      TransferTo : new Field('Transfer To', 'transferTo')
    },
    searchList4: {
      Email: new Field('Email', 'email'),
      /*CreatedDate: new Field('Created Date', 'createdDate'),
      Roles: new Field('Roles', 'roles'),
      // Active: new Field('Active', 'isActive')
      Active: new Field('Status', 'status')*/
    },
    Active: {
      Active: new Field('Active', 'true'),
      NotActive: new Field('Not Active', 'false')
    },
    revokestype: {
      RevokeSatellite : new Field('Undertaking', 'RE_UNDERTAKING'),
      TransferSatellite : new Field('Transfer', 'RE_TRANSFER')
    },
    sectors: {
      Energy : new Field('Energy', 'Energy'),
      Materials : new Field('Materials', 'Materials'),
      Industrials : new Field('Industrials', 'Industrials'),
      ConsumerDiscretionary : new Field('Consumer Discretionary', 'Consumer Discretionary'),
      ConsumerStaples : new Field('Consumer Staples', 'Consumer Staples'),
      HealthCare : new Field('Health Care', 'Health Care'),
      Financials : new Field('Financials', 'Financials'),
      InformationTechnology : new Field('Information Technology', 'Information Technology'),
      CommunicationServices : new Field('Communication Services', 'Communication Services'),
      Utilities : new Field('Utilities', 'Utilities'),
      RealEstate : new Field('Real Estate', 'Real Estate')
    },
    publicly: {
      Yes: new Field('Yes', 'true'),
      No: new Field('No', 'false')
    },
    verified: {
      Yes: new Field('Yes', 'yes'),
      No: new Field('No', 'no'),
      Partial: new Field('Partial', 'partial')
    }
  },
  patterns: {
    validUrl: '(https?://)?([\\da-z.-]+)((\\.([a-z.]{2,6}))|(:\\d{2,6}))[/\\w .-]*/?',
    validEmail: /^\w+([-+.\']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
  }
};

